import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { SelectProductFacade } from './+state';
import { SelectProductStateModule } from './+state/select-product.state.module';
import { ProductService } from './services';

@NgModule({
  imports: [CommonModule, SelectProductStateModule],
})
export class DomainSelectProductModule {
  public static forRoot(): ModuleWithProviders {
    return {
      ngModule: DomainSelectProductModule,
      providers: [ProductService, SelectProductFacade],
    };
  }
}
